module.exports = __webpack_public_path__ + "static/img/zs.1778636131768.png";